// SemanaVolteon.jsx
import React, { useEffect } from "react";
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import './SemanaVolteon.css';
import '../components/MainPageComponents/welcome.css';
import { getOrderProducts } from '../services/getOrders';
import { migrateDraftToNewOrder } from "../services/posOrders";
import Welcome from "../components/MainPageComponents/welcome";
import Dinamicas from "../components/SemanaVolteon/Dinamicas";

const SemanaVolteon = () => {
    return (
        <div>
            <Header />
            <Welcome title="Semana Volteon" subtitle="Disfrutá Semana Volteon con las mejores dinámicas y descuentos. Del 28 de abril al 3 de mayo"/>
            <Dinamicas />
            <div className="semana-container">
            <div className="dinamica"> <
                h1> Disfrutá de los descuentos diarios </h1></div>
            </div>
            <div className="semana-container">
                {/* Lunes 28 de abril */}
                <div className="dia">
                    <h1>Lunes 28 de abril</h1>
                    <div className="productos-row">
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/puentes.jpg'} alt="Puentes" className="final-image"/>
                            <p className="product-title">Kit de puentes</p>
                            <div className="price-container">
                                <p className="prev-price">₡2800</p>
                                <p className="final-price">₡2000</p>
                            </div>
                        </div>
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/cable.jpg'} alt="Cable" className="final-image"/>
                            <p className="product-title">3m de cable</p>
                            <div className="price-container">
                                <p className="prev-price">₡1350</p>
                                <p className="final-price">₡1000</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Martes 29 de abril */}
                <div className="dia">
                    <h1>Martes 29 de abril</h1>
                    <div className="productos-row">
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/grande.jpg'} alt="Placa Grande" className="final-image"/>
                            <p className="product-title">Placa Grande</p>
                            <div className="price-container">
                                <p className="prev-price">₡5000</p>
                                <p className="final-price">₡4000</p>
                            </div>
                        </div>
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/mediana.jpg'} alt="Placa Mediana" className="final-image"/>
                            <p className="product-title">Placa Mediana</p>
                            <div className="price-container">
                                <p className="prev-price">₡3500</p>
                                <p className="final-price">₡2800</p>
                            </div>
                        </div>
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/mini.jpg'} alt="Placa Mini" className="final-image"/>
                            <p className="product-title">Placa Mini</p>
                            <div className="price-container">
                                <p className="prev-price">₡1500</p>
                                <p className="final-price">₡1200</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Miércoles 30 de abril */}
                <div className="dia">
                    <h1>Miércoles 30 de abril</h1>
                    <div className="productos-row">
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/pico.jpg'} alt="Pico" className="final-image"/>
                            <p className="product-title">Pico Pi H</p>
                            <div className="price-container">
                                <p className="prev-price">₡6000</p>
                                <p className="final-price">₡5000</p>
                            </div>
                        </div>
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/superior.jpg'} alt="Superior" className="final-image"/>
                            <p className="product-title">Superior ESP</p>
                            <div className="price-container">
                                <p className="prev-price">₡10000</p>
                                <p className="final-price">₡8000</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Jueves 1 de mayo */}
                <div className="dia">
                    <h1>Viernes 2 de mayo</h1>
                    <div className="productos-row">
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/r3.jpg'} alt="Resistor 3" className="final-image"/>
                            <p className="product-title">UNO R3</p>
                            <div className="price-container">
                                <p className="prev-price">₡10000</p>
                                <p className="final-price">₡8000</p>
                            </div>
                        </div>
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/r4.jpg'} alt="Resistor 4" className="final-image"/>
                            <p className="product-title">UNO R4</p>
                            <div className="price-container">
                                <p className="prev-price">₡16650</p>
                                <p className="final-price">₡15000</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Viernes 2 y Sábado 3 de mayo */}
                <div className="dia">
                    <h1>Sábado 3 de mayo</h1>
                    <div className="productos-row">
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/basico.jpg'} alt="Kit Básico" className="final-image"/>
                            <p className="product-title">Kit Básico</p>
                            <div className="price-container">
                                <p className="prev-price">₡19950</p>
                                <p className="final-price">₡16950</p>
                            </div>
                        </div>
                        <div className="producto">
                            <img src={'/images/SemanaVolteon/ultimate.jpg'} alt="Kit Ultimate" className="final-image"/>
                            <p className="product-title">Kit Ultimate</p>
                            <div className="price-container">
                                <p className="prev-price">₡29950</p>
                                <p className="final-price">₡25400</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default SemanaVolteon;

